/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamStatisticsListV2 = {
    type: 'array',
    contains: {
        type: 'TeamStatisticsV2',
    },
} as const;
